<template>
    <div>
        <button class="info-terms__prev" @click.prevent="goBack">
            <Icon name="arrow-left" />
        </button>
    </div>
    <div class="info-terms">
        <h1>Пользовательское соглашение и политика конфиденциальности</h1>

        <h2>1. Общие положения</h2>
        <p>Настоящее Пользовательское Соглашение (далее Соглашение) регулирует отношения между владельцем мобильного приложения "События и развлечения" с одной стороны и пользователем приложения с другой.</p>

        <h2>2. Согласие с Соглашением</h2>
        <p>Пользователь подтверждает, что отметка им чекбокса "Согласен с пользовательским соглашением" и использование приложения означает полное согласие Пользователя со всеми положениями настоящего Соглашения.</p>

        <h3>2.1. Лицензионное соглашение конечного пользователя (EULA)</h3>
        <p>Используя приложение, вы соглашаетесь соблюдать следующие правила:</p>
        <ul>
            <li>Запрещается публиковать контент, содержащий:
                <ul>
                    <li>Материалы сексуального или порнографического характера</li>
                    <li>Разжигание ненависти, дискриминацию или ксенофобию</li>
                    <li>Угрозы, травлю или оскорбительное поведение</li>
                    <li>Спам, мошенничество или ложную информацию</li>
                    <li>Любой незаконный контент</li>
                </ul>
            </li>
            <li>Вы не должны:
                <ul>
                    <li>Оскорблять или преследовать других пользователей</li>
                    <li>Распространять личную информацию третьих лиц без согласия</li>
                    <li>Создавать фейковые аккаунты или выдавать себя за других</li>
                    <li>Запрещается сексуальное насилие над детьми и их эксплуатация</li>
                </ul>
            </li>
        </ul>
        <p>В приложении реализованы:</p>
        <ul>
            <li>Система автоматической модерации контента</li>
            <li>Возможность жаловаться на нарушения через функцию "Пожаловаться"</li>
            <li>Функция блокировки нежелательных пользователей</li>
        </ul>
        <p>Администрация обязуется:</p>
        <ul>
            <li>Рассматривать жалобы в течение 24 часов</li>
            <li>Удалять нарушающий правила контент</li>
            <li>Блокировать пользователей, нарушающих соглашение</li>
        </ul>

        <h2>3. Права и обязанности сторон</h2>
        <h3>3.1 Пользователь имеет право:</h3>
        <ul>
            <li>Использовать информацию из приложения в личных некоммерческих целях</li>
        </ul>
        <h3>3.2 Администрация имеет право:</h3>
        <ul>
            <li>По своему усмотрению и необходимости создавать, изменять, отменять данные правила</li>
            <li>Создавать, изменять, удалять информацию в мобильном приложении, менять его функционал</li>
        </ul>
        <h3>3.3 Пользователь обязуется:</h3>
        <ul>
            <li>Не использовать информацию из приложения в коммерческих целях</li>
            <li>Не копировать и не распространять материалы из приложения без указания прямой явной ссылки на мобильное приложение</li>
            <li>Вовремя устанавливать обновления, опубликованные в магазинах приложений Google Play Market, App Store</li>
        </ul>

        <h2>4. Ответственность сторон</h2>
        <p>4.1 Администрация не несет ответственности за актуальность информации, представленной в приложении.</p>
        <p>4.2 Вся информация, предоставляемая в приложении, носит сугубо информационный характер и не должна истолковываться как индивидуальная рекомендация или указание к действию.</p>
        <p>4.3 Администрация не несет ответственности за последствия применения указанной в приложении информации.</p>
        <p>4.4 Администрация приложения не несет ответственность за утерю пользователем данных для входа в учетную запись в приложении и не сообщает данные для входа по запросу или каким-либо иным способом.</p>
        <p>4.5 Администрация приложения не гарантирует работоспособность приложения, в случае если сбои в работе приложения, утеря внесенных данных и иные технические сложности связаны с работоспособностью сторонних сервисов, используемых в приложении, а также при использовании устаревшей версии приложения, введении различного рода блокировок и санкций со стороны государственных органов и платежных систем, сторонних сервисов, обеспечивающих работу приложения и хранение данных.</p>

        <h2>5. Персональные данные и Политика конфиденциальности</h2>
        <p>5.1 Для полноценного функционирования приложения Пользователь соглашается предоставить и дает согласие на обработку персональных данных в соответствии с ФЗ 27.07.2006 №152-ФЗ «О персональных данных». Под «персональными данными» понимаются данные, необходимые для входа в приложение, а также данные, заполняемые Пользователем и включающие в себя:</p>
        <ul>
            <li>Имя</li>
            <li>Адрес электронной почты</li>
            <li>Фотографии</li>
        </ul>
        <p>5.2 Администрация гарантирует конфиденциальность в отношении вносимых данных и предоставляет к ним доступ только тем сотрудникам, которым эта информация нужна для обеспечения полноценного функционирования приложения.</p>
        <p>5.3 Полученная Администрацией информация не подлежит разглашению, за исключением случаев, когда ее раскрытие является обязательным по законодательству Российской Федерации или необходимо для работы приложения и его функций.</p>
        <p>5.4 Удаление данных</p>
        <p>Пользователь может полностью удалить данные из приложения, включая персональные данные и учетную запись в приложении. Для этого необходимо удалить аккаунт в приложении.</p>
        <p>Для удаления аккаунта нужно войти в верхнее меню приложения на главном экране, далее выбрать пункт Настройки, перейти в пункт Удалить аккаунт. Удаление аккаунта приводит к полному удалению данных (включая персональные данные, данные, внесенные в рамках функционала приложения, данные об учетной записи) без возможности дальнейшего восстановления.</p>

        <h2>7. Условия действия Соглашения</h2>
        <p>7.1 Данное Соглашение вступает в силу в момент первого входа в мобильное приложение и установки чекбокса о согласии с Соглашением.</p>
        <p>7.2 Соглашение перестает действовать при появлении его новой версии.</p>
        <p>7.3 Администрация оставляет за собой право в одностороннем порядке изменять данное соглашение по своему усмотрению.</p>
        <p>7.4 Администрация не оповещает пользователей об изменении в Соглашении. Изменения публикуются в приложении в разделе Настройки/Политика конфиденциальности.</p>
    </div>
</template>

<script setup>
const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss">
body:has(.info-terms) {
    background: #101214;
    color: #fff;
    #app {
        background: #101214;
    }
}
.info-terms {
    padding-bottom: 2rem;
    word-break: break-word;
    *:not(:last-child) {
        margin-bottom: 1rem;
    }

    &__prev {
        font-size: 36px;
        padding: 15px 15px 15px 0;
    }
}
</style>